"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitPayloadHex = void 0;
const redstone_constants_1 = require("redstone-protocol/src/common/redstone-constants");
const ethers_1 = require("ethers");
const assert_1 = require("assert");
const UNSIGNED_METADATA_BYTE_SIZE_BS = 3;
function splitPayloadHex(payloadHex) {
    //TODO: assert value size == 32;
    const DATA_PACKAGE_BS = redstone_constants_1.DATA_FEED_ID_BS +
        redstone_constants_1.DEFAULT_NUM_VALUE_BS +
        redstone_constants_1.TIMESTAMP_BS +
        redstone_constants_1.DATA_POINTS_COUNT_BS +
        redstone_constants_1.DATA_POINT_VALUE_BYTE_SIZE_BS +
        redstone_constants_1.SIGNATURE_BS;
    const unsignedMetadataBS = ethers_1.BigNumber.from("0x" +
        payloadHex.substring(payloadHex.length -
            2 * (redstone_constants_1.REDSTONE_MARKER_BS + UNSIGNED_METADATA_BYTE_SIZE_BS), payloadHex.length - 2 * redstone_constants_1.REDSTONE_MARKER_BS)).toNumber();
    const metadataBS = redstone_constants_1.REDSTONE_MARKER_BS +
        UNSIGNED_METADATA_BYTE_SIZE_BS +
        unsignedMetadataBS +
        redstone_constants_1.DATA_PACKAGES_COUNT_BS;
    const metadata = payloadHex.substring(payloadHex.length - 2 * metadataBS, payloadHex.length);
    const dataPackageCount = ethers_1.BigNumber.from("0x" + metadata.substring(0, redstone_constants_1.DATA_PACKAGES_COUNT_BS * 2)).toNumber();
    (0, assert_1.equal)(payloadHex.length - 2 * metadataBS, 2 * DATA_PACKAGE_BS * dataPackageCount, "Must be implemented for multi-datapoint packages");
    const dataPackageChunks = [];
    for (let i = 0; i < dataPackageCount; i++) {
        dataPackageChunks.push(payloadHex.substring(i * 2 * DATA_PACKAGE_BS, (i + 1) * 2 * DATA_PACKAGE_BS));
    }
    return { dataPackageChunks, metadata };
}
exports.splitPayloadHex = splitPayloadHex;
//# sourceMappingURL=split-payload-hex.js.map